import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// //解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


const vueRouter = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/components/project-files/client'],resolve),
      redirect:{
        path:"/client"
      }
    },
    {
      path: '/orderPay',
      name:'/orderPay',
      component: resolve => require(['@/components/project-files/orderPay'],resolve),
    },
    {
      path: '/pay',
      name:'/pay',
      component: resolve => require(['@/components/project-files/pay'],resolve),
    },
    {
      path: '/orderType',
      name:'/orderType',
      component: resolve => require(['@/components/project-files/orderType'],resolve),
    },
    {
      path: '/common',
      component: resolve => require(['@/components/common/common'],resolve) ,
      children: [
        {
          path: '/client',
          name: 'client',
          component: resolve => require(['@/components/project-files/client'],resolve)
        },
        {
          path: '/order',
          name: 'order',
          component: resolve => require(['@/components/project-files/order'],resolve)
        },
      ]
    },
    {
      path: '*',
      name: 'notFound',
      component: resolve => require(['@/components/common/notFound'],resolve)
    },
  ]
})


export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js